import { useMutation } from "@tanstack/react-query";
import api from "../lib/api";
import toast from "react-hot-toast";

export const useLogin = () => {
    return useMutation({
        mutationFn: async ({ email, password }) => {
            const { data } = await api.post("/user/login", { email, password });
            if (!data.success) {
                throw new Error(data.message || "Login failed");
            }
            return data.data;
        },
        onSuccess: (data) => {
            const { user, token } = data;

            // Store token and user data
            localStorage.setItem("company_token", token);
            localStorage.setItem("user_data", JSON.stringify(user));

            // Store role and permissions separately
            const role = user?.role || "";
            let permissions = [];
            if (Array.isArray(user?.permissions)) {
                permissions = user.permissions.map(p => typeof p === 'string' ? p : (p.slug || p.name));
            }

            localStorage.setItem("user_role", role);
            localStorage.setItem("user_permissions", JSON.stringify(permissions));

            toast.success(`Welcome back, ${user.name || "User"}!`);
        },
        onError: (error) => {
            const message = error.message || "Invalid email or password";
            toast.error(message);
        },
    });
};